const config = {
  BUCKET_URL: process.env.REACT_APP_ENVIRONMENT === 'development' ? process.env.REACT_APP_BUCKET_URL : process.env.REACT_APP_BUCKET_URL_PROD,
  CONFIGURATOR_BASE_URL: process.env.REACT_APP_CONFIGURATOR_BASE_URL,
};

export default config;